<template>
  <!-- Navbar -->
 <nav :class="[
  'w-full top-0 z-50 transition-all duration-300',
  isHome ? (isScrolled ? 'fixed bg-white shadow' : 'absolute bg-transparent') : 'relative bg-white shadow'
]">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <!-- Mobile header -->
      <div class="flex items-center justify-between h-12 md:hidden">
        <!-- Logo mobile -->
        <a href="/" class="flex items-center space-x-2">
<img :src="isHome ? (isScrolled ? logoGreen : logoWhite) : logoGreen" alt="Logo" class="h-14 transition-all duration-300" />
          <span v-if="isPro" class="text-sm font-semibold text-gray-700">Pro</span>
        </a>

        <!-- Hamburger -->
        <button
          @click="toggleSidebar"
          aria-label="Toggle navigation"
          class="btn btn-outline btn-secondary btn-sm btn-square"
        >
          <svg
            v-if="!sidebarOpen"
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6 block"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
          <svg
            v-else
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6 block"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <!-- Desktop menu -->
      <div class="hidden md:flex md:items-center md:justify-between h-12">
        <!-- Logo desktop -->
        <a href="/" class="flex items-center space-x-2">
<img :src="isHome ? (isScrolled ? logoGreen : logoWhite) : logoGreen" alt="Logo" class="h-20 transition-all duration-300" />
        </a>

        <!-- Menu principal -->
        <ul class="menu menu-horizontal gap-4 text-base">
          <!-- Ajoute tes liens ici -->
        </ul>

        <!-- Zone utilisateur -->
        <div class="relative">
          <template v-if="isLogin">
            <button
              @click="dropdownUserOpen = !dropdownUserOpen"
              class="text-sm font-medium text-gray-800 border border-gray-300 rounded-md px-4 py-2 hover:bg-gray-100"
            >
              {{ user.prenom + ' ' + user.nom || 'Mon Profil' }}
            </button>

            <div
              v-if="dropdownUserOpen"
              class="absolute right-0 mt-2 bg-white border rounded shadow-md z-50 w-48"
              @mouseleave="dropdownUserOpen = false"
            >
              <a href="/userAccount" class="block px-4 py-2 text-gray-700 hover:bg-gray-100">Voir mon profil</a>
              <a href="/booking" class="block px-4 py-2 text-gray-700 hover:bg-gray-100">Mes rendez-vous</a>
              <button @click="logout" class="w-full text-left px-4 py-2 text-red-600 hover:bg-gray-100">Se déconnecter</button>
            </div>
          </template>

          <template v-else>
            <a :href="isPro ? '/' : '/espace-pro'" class="text-sm font-medium text-white hover:underline mr-4">
              {{ isPro ? 'Espace Client' : 'Espace Pro' }}
            </a>
            <a
              :href="isPro ? 'https://pro.VetoMinute.fr' : '/signup'"
              class="text-gray-800 bg-white text-sm font-medium border border-gray-400 rounded-md px-4 py-2 hover:bg-gray-100 mr-2"
            >
              Se connecter
            </a>
            <a
              :href="isPro ? 'https://pro.VetoMinute.fr' : '/signup'"
              class="text-white text-sm font-medium bg-[#18b7bd] rounded-md px-4 py-2 hover:bg-white hover:text-[#18b7bd] hover:border"
            >
              S'inscrire
            </a>
          </template>
        </div>
      </div>
    </div>

    <!-- Sidebar mobile -->
    <div
      :class="[
        'fixed top-0 left-0 h-full w-64 bg-white shadow-lg transition-transform duration-300 z-50 md:hidden',
        sidebarOpen ? 'translate-x-0' : '-translate-x-full'
      ]"
      role="dialog"
      aria-modal="true"
    >
      <div class="p-4 flex items-center justify-between">
        <a href="/" class="flex items-center space-x-2">
          <img src="./assets/logo_white.svg" alt="Logo" class="h-14" />
        </a>
        <button @click="closeSidebar" aria-label="Close sidebar" class="btn btn-sm btn-outline btn-secondary btn-square">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <ul class="menu p-4 space-y-3">
        <!-- Zone utilisateur mobile -->
        <li>
          <template v-if="isLogin">
            <button
              @click="dropdownUserMobileOpen = !dropdownUserMobileOpen"
              class="w-full text-left text-sm font-medium text-gray-800 border border-gray-300 rounded-md px-4 py-2 hover:bg-gray-100"
            >
              {{ user.prenom + ' ' + user.nom || 'Mon Profil' }}
            </button>

            <div v-if="dropdownUserMobileOpen" class="mt-1 border rounded shadow-md bg-white">
              <a href="/userAccount" class="block px-4 py-2 hover:bg-gray-100">Voir mon profil</a>
              <a href="/booking" class="block px-4 py-2 hover:bg-gray-100">Mes rendez-vous</a>
              <button @click="logout" class="w-full text-left px-4 py-2 text-red-600 hover:bg-gray-100">Se déconnecter</button>
            </div>
          </template>

          <template v-else>
            <a :href="isPro ? '/' : '/espace-pro'" class="block text-sm font-medium text-gray-700 hover:underline mb-2">
              {{ isPro ? 'Espace Client' : 'Espace Pro' }}
            </a>
            <a
              :href="isPro ? 'https://pro.VetoMinute.fr' : '/signup'"
              class="block text-gray-800 text-sm font-medium border border-gray-400 rounded-md px-4 py-2 hover:bg-gray-100 mb-2"
            >
              Se connecter
            </a>
            <a
              :href="isPro ? 'https://pro.VetoMinute.fr' : '/signup'"
              class="block text-white text-sm font-medium bg-blue-600 rounded-md px-4 py-2 hover:bg-blue-700"
            >
              S'inscrire
            </a>
          </template>
        </li>
      </ul>
    </div>

    <!-- Overlay -->
    <div v-if="sidebarOpen" @click="closeSidebar" class="fixed inset-0 bg-black bg-opacity-25 z-40 md:hidden"></div>
  </nav>

  <!-- Routes -->
  <router-view />

  <!-- Footer main section -->
  <footer class="bg-[#18b7bd] text-white py-16 px-6 md:px-20">
    <div class="max-w-7xl mx-auto px-4 py-16">
      <div class="flex flex-col sm:flex-row sm:justify-start sm:space-x-24">
        <!-- Logo -->
        <div class="flex flex-col items-start mb-12 sm:mb-0">
          <div class="flex-shrink-0 flex items-center">
            <img src="./assets/footer_logo.svg" alt="Logo" class="h-64" />
          </div>
        </div>
        <!-- À propos -->
        <div class="flex flex-col space-y-2 mb-12 sm:mb-0">
          <h2 class="text-white text-lg font-semibold mb-4">À propos de VetoMinute</h2>
          <router-link to="/espace-pro" class="text-white hover:text-gray-300">Ajoutez votre établissement</router-link>
          <router-link to="https://pro.VetoMinute.fr" class="text-white hover:text-gray-300">Rejoignez-nous</router-link>
          <router-link to="/cgu" class="text-white hover:text-gray-300">CGU</router-link>
          <router-link to="/PolitiqueConfidentialite" class="text-white hover:text-gray-300">Politique de confidentialité</router-link>
          <span class="text-white">Gestion des cookies</span>
        </div>
        <!-- Prestations -->
        <div class="flex flex-col space-y-2 mb-12 sm:mb-0">
          <h2 class="text-white text-lg font-semibold mb-4">Trouvez votre prestation</h2>
          <router-link to="/services/coiffeur" class="text-white hover:text-gray-300">Coiffeur</router-link>
          <router-link to="/services/institut-de-beaute" class="text-white hover:text-gray-300">Institut de beauté</router-link>
          <router-link to="/services/barbier" class="text-white hover:text-gray-300">Barbier</router-link>
          <router-link to="/services/manucure" class="text-white hover:text-gray-300">Manucure et beauté des pieds</router-link>
          <router-link to="/services/spa" class="text-white hover:text-gray-300">Spa</router-link>
          <router-link to="/services/massage" class="text-white hover:text-gray-300">Massage</router-link>
        </div>
        <!-- Recherches fréquentes -->
        <div class="flex flex-col space-y-2">
          <h2 class="text-white text-lg font-semibold mb-4">Recherches fréquentes</h2>
          <router-link to="/search?query=coiffeur%20paris" class="text-white hover:text-gray-300">Coiffeur Paris</router-link>
          <router-link to="/search?query=coiffeur%20bordeaux" class="text-white hover:text-gray-300">Coiffeur Bordeaux</router-link>
          <router-link to="/search?query=coiffeur%20lyon" class="text-white hover:text-gray-300">Coiffeur Lyon</router-link>
          <router-link to="/search?query=coiffeur%20toulouse" class="text-white hover:text-gray-300">Coiffeur Toulouse</router-link>
        </div>
      </div>
    </div>
  </footer>

  <!-- Bottom bar -->
  <div class="bg-[#2A2623] border-t border-gray-800 flex items-center justify-center md:justify-center px-6 md:px-20 py-4 text-white text-sm">
    <p class="text-sm text-white">
      Réalisé par <span class="text-white font-semibold">DATAFUSE</span> – Tous droits réservés © <span class="text-white">VetoMinute</span>
    </p>
  </div>
</template>

<script>
import logoWhite from '@/assets/logo_white.svg'
import logoGreen from '@/assets/logo_veto_green.svg'

export default {
  data() {
    return {
      email: '',
      logoWhite ,
      logoGreen ,
      isPro: true,
      isMenuOpen: false,
      isLogin: false,
      dropdownOpen: false,
      sidebarOpen: false,
      dropdownUserOpen: false,
      dropdownUserMobileOpen: false,
      isScrolled: false, // ⇦ nouvel état pour le scroll
      user: {
        nom: '',
        prenom: '',
        id: '',
      },
    };
  },
  computed: {
    isHome() {
    return this.$route.path === '/';
  },
  },
  mounted() {
    // Détection du contexte Pro / Client
this.isPro = this.$route.path.includes('/espace-pro');

    // Listener scroll
    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll(); // mise à jour initiale

    // Auth check (inchangé)
    const token = localStorage.getItem('clientToken');
    const expiration = parseInt(localStorage.getItem('clientToken_expire'), 10);
    const now = Date.now();
    if (token && (!expiration || now < expiration)) {
      const newExpireTime = now + 4 * 60 * 60 * 1000;
      localStorage.setItem('clientToken_expire', newExpireTime.toString());
      fetch('https://b53c7d5edf32.ngrok-free.app/api/clients/verify-token', {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.message === 'Token valide') {
            this.isLogin = true;
            this.user = {
              nom: data.user.nom,
              prenom: data.user.prenom,
              id: data.user.id,
            };
            localStorage.setItem('USERID', data.user.id);
          } else {
            this.logout();
          }
        })
        .catch((err) => {
          console.error('Erreur lors de la vérification du token :', err);
          this.logout();
        });
    } else {
      this.logout();
    }
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    // Met à jour l'état isScrolled suivant la position de la page
    handleScroll() {
      this.isScrolled = window.scrollY > 10;
    },
    toggleSidebar() {
      this.sidebarOpen = !this.sidebarOpen;
    },
    closeSidebar() {
      this.sidebarOpen = false;
    },
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    logout() {
      localStorage.removeItem('clientToken');
      localStorage.removeItem('clientToken_expire');
      localStorage.removeItem('USERID');
      this.isLogin = false;
      this.dropdownOpen = false;
      this.user = { nom: '', prenom: '', id: '' };
    },
  },
  watch: {
  '$route.path'() {
    this.handleScroll(); // pour forcer la mise à jour après un changement de page
  },
}
};
</script>




<style>
/* Police globale */
body {
  font-family: 'Poppins', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #1f2937; /* gris foncé élégant */
  background-color: #ffffff;
  margin: 0;
  padding: 0;
}

/* Structure principale */
#app {
  text-align: center;
}

/* Titres */
h1 {
  font-size: 2.25rem; /* 36px */
  font-weight: 700;
  margin-bottom: 1rem;
  color: #111827;
}

h2 {
  font-size: 1.875rem; /* 30px */
  font-weight: 600;
  margin-bottom: 0.75rem;
  color: #1f2937;
}

h3 {
  font-size: 1.5rem; /* 24px */
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #1f2937;
}

h4 {
  font-size: 1.25rem; /* 20px */
  font-weight: 500;
  color: #374151;
}

p {
  font-size: 1rem; /* 16px */
  font-weight: 400;
  line-height: 1.6;
  color: #4b5563;
  margin-bottom: 1rem;
}

/* Liens */
a {
  color: #2563eb;
  text-decoration: none;
  transition: color 0.2s ease;
}

a:hover {
  color: #1d4ed8;
}

/* Navigation */
nav {
  padding: 20px 30px;
  cursor: pointer;
  background-color: white;

}

nav a {
  color: #2c3e50;
  font-weight: 500;
}

nav a.router-link-exact-active {
  color: #2563eb;
}

/* Boutons (optionnel) */
button {
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
}
</style>